'use client';
import { TextareaAutosize as BaseTextareaAutosize, TextareaAutosizeProps } from '@mui/base/TextareaAutosize';
import { grey } from '@mui/material/colors';
import styled from '@mui/system/styled';

export const CCTextarea = styled(BaseTextareaAutosize)(
  () => `
    box-sizing: border-box;
    width: 100%;
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 6px 10px;
    border-radius: 8px;
    color: ${grey[900]};
    background: transparent;
    border: none;
    outline: none;
    position: relative;
    z-index: 1;
    resize: none;
    display: block;
    caret-color: ${grey[900]};
    
    &:hover {
      outline: none;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 0;
    }
  `,
);

export type CCTextareaProps = TextareaAutosizeProps;
